export interface IBeneficiary {
  civility?: 'Monsieur' | 'Madame' | '';
  lastNameOfBirth?: string;
  lastName?: string;
  firstName?: string[] | string;
  birthday?: string;
  cityOfBirth?: string;
  isoTwoCountryOfBirth?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  country?: string;
  sharePercentage?: string; // Exemple : 25 pour 25%
  [key: string]: any; // Pour d'autres champs dynamiques
}

export interface IFirstCustomer {
  externalRef?: string;
  civility?: 'Monsieur' | 'Madame' | '';
  lastName?: string;
  lastNameOfBirth?: string;
  firstName?: string[] | string;
  siret?: string;
  socialReason?: string;
  birthday?: string;
  cityOfBirth?: string;
  isoTwoCountryOfBirth?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  country: string;
  phoneNumber?: string;
  email?: string;
  iban?: string;
  bic?: string;
  clauseType?: string;
  beneficiaries?: IBeneficiary[];
  [key: string]: any; // Pour permettre d'autres champs dynamiques
}

export const defaultValue: Readonly<IFirstCustomer> = {
  externalRef: '',
  civility: '',
  lastName: '',
  lastNameOfBirth: '',
  firstName: '',
  siret: '',
  socialReason: '',
  birthday: '',
  cityOfBirth: '',
  isoTwoCountryOfBirth: '',
  address: '',
  zipCode: '',
  city: '',
  country: 'FR',
  phoneNumber: '',
  email: '',
  iban: '',
  bic: '',
  clauseType: '',
  beneficiaries: [] // Liste des bénéficiaires vide
};
